import z from "zod";

export enum CountryCodeEnum {
  AT = "at",
  BE = "be",
  CZ = "cz",
  DK = "dk",
  DE = "de",
  EE = "ee",
  ES = "es",
  FI = "fi",
  FR = "fr",
  GR = "gr",
  HR = "hr",
  HU = "hu",
  IT = "it",
  LT = "lt",
  LV = "lv",
  NL = "nl",
  NO = "no",
  PL = "pl",
  PT = "pt",
  RO = "ro",
  SE = "se",
  SI = "si",
  SK = "sk",
}

export enum LanguageCodeEnum {
  SE = "sv",
  NO = "nb",
  EN = "en",
  FI = "fi",
  DK = "da",
  NL = "nl",
}

export enum CurrencyCodeEnum {
  SEK = "SEK",
  NOK = "NOK",
  EUR = "EUR",
  DKK = "DKK",
}

export enum CountryNameEnum {
  FI = "Finland",
  DK = "Denmark",
  NL = "Netherlands",
  AT = "Austria",
  BE = "Belgium",
  CZ = "Czechia",
  DE = "Germany",
  EE = "Estonia",
  ES = "Spain",
  FR = "France",
  GR = "Greece",
  HR = "Croatia",
  HU = "Hungary",
  IT = "Italy",
  LT = "Lithuania",
  LV = "Latvia",
  NO = "Norway",
  PL = "Poland",
  PT = "Portugal",
  RO = "Romania",
  SE = "Sweden",
  SI = "Slovenia",
  SK = "Slovakia",
}

export enum ElevateCodeEnum {
  SE = "NG_NG_SE_sv",
  NO = "NG_NG_NO_nb",
  EU = "NG_NOGA_EU_en",
  FI = "NG_NOGA_EU_fi",
  DK = "NG_NOGA_EU_da",
  NL = "NG_NOGA_EU_nl",
}

export enum ContentfulLocaleEnum {
  SE = "sv-SE",
  NO = "nb-NO",
  EU = "en-GB",
  FI = "fi-FI",
  DK = "da-DK",
  NL = "nl-NL",
}

export enum SiteLocaleEnum {
  AT = "en-at",
  BE = "en-be",
  CZ = "en-cz",
  DK = "dk",
  DE = "en-de",
  EE = "en-ee",
  ES = "en-es",
  FI = "fi",
  FR = "en-fr",
  GR = "en-gr",
  HR = "en-hr",
  HU = "en-hu",
  IT = "en-it",
  LT = "en-lt",
  LV = "en-lv",
  NO = "",
  NL = "nl",
  PL = "en-pl",
  PT = "en-pt",
  RO = "en-ro",
  SE = "",
  SI = "en-si",
  SK = "en-sk",
}

export enum ServiceLocaleEnum {
  AT = "en-at",
  BE = "en-be",
  CZ = "en-cz",
  DK = "da-dk",
  DE = "en-de",
  EE = "en-ee",
  ES = "en-es",
  FI = "fi-fi",
  FR = "en-fr",
  GR = "en-gr",
  HR = "en-hr",
  HU = "en-hu",
  IT = "en-it",
  LT = "en-lt",
  LV = "en-lv",
  NO = "nb-no",
  NL = "nl-nl",
  PL = "en-pl",
  PT = "en-pt",
  RO = "en-ro",
  SE = "sv-se",
  SI = "en-si",
  SK = "en-sk",
}

export enum SiteNameEnum {
  SE = "Nordiska Galleriet",
  NO = "Nordiska Galleriet",
  DK = "Nordiska Galleriet",
  FI = "Nordiska Galleriet",
  NL = "NO GA",
  EU = "NO GA",
}
export enum PSPEnum {
  WALLEY = "walley",
  ADYEN = "adyen",
}

export enum DomainEnum {
  NOGA = "https://www.no-ga.com",
  NGSE = "https://www.nordiskagalleriet.se",
  NGNO = "https://www.nordiskagalleriet.no",
}

export type CountryCode = keyof typeof CountryCodeEnum;
export type LanguageCode = keyof typeof LanguageCodeEnum;
export type CurrencyCode = keyof typeof CurrencyCodeEnum;
export type CountryName = keyof typeof CountryNameEnum;
export type ElevateCode = keyof typeof ElevateCodeEnum;
export type SiteLocale = keyof typeof SiteLocaleEnum;
export type PSP = keyof typeof PSPEnum;
export type SiteName = keyof typeof SiteNameEnum;

export const market = z
  .object({
    flag: z.string(),
    locale: z.string().regex(/^[a-z]{2}-[a-z]{2}$/),
    upperCaseLocale: z.string().regex(/^[a-z]{2}-[A-Z]{2}$/),
    contentfulLocale: z.enum(ContentfulLocaleEnum),
    siteLocale: z.enum(SiteLocaleEnum),
    currency: z.enum(CurrencyCodeEnum),
    countryCode: z.enum(CountryCodeEnum),
    countryName: z.enum(CountryNameEnum),
    languageCode: z.enum(LanguageCodeEnum),
    elevateMarket: z.enum(ElevateCodeEnum),
    siteName: z.enum(SiteNameEnum),
    bookingMarket: z.string().optional(),
    externalStoreId: z.string(),
    searchPathName: z.string(),
    domain: z.enum(DomainEnum),
    imageCdn: z.string(),
  })
  .and(
    z.discriminatedUnion("psp", [
      z.object({
        psp: z.literal(PSPEnum.WALLEY),
        walleyStoreCodeB2B: z.number(),
        walleyStoreCodeB2C: z.number(),
      }),
      z.object({
        psp: z.literal(PSPEnum.ADYEN),
      }),
    ]),
  );

export type Market = z.infer<typeof market>;

export const contentfulSlugSchema = z.object({
  "nb-NO": z.string().optional(),
  "sv-SE": z.string().optional(),
  "fi-FI": z.string().optional(),
  "da-DK": z.string().optional(),
  "en-GB": z.string().optional(),
  "nl-NL": z.string().optional(),
});
